import React from "react";
import FooterwithoutLogin from "./footerwithoutLogin";
import { FcSurvey } from "react-icons/fc";

function Refundpolicy() {
  return (
    <>
      <div className="container my-5">
      <h1 className="card-title mb-4 text-center text-uppercase" style={{fontSize:"40px",fontWeight:"bold"}}>
            <FcSurvey className="me-1" style={{height:"40px", width:"40px"}}/>
              Refund Policy
            </h1>
            <hr></hr>
        <div className="card border-0">
          <div
            className="card-body p-4"
            style={{ fontSize: "1.3rem", lineHeight: "1.8" }}
          >
         

            <p className="" style={{ fontSize: "1.1rem" }}>
              Our refund policy is valid <strong>72 hours before</strong> the
              scheduled practical training. Unfortunately, if this 72-hour
              window has passed, we cannot offer a refund or exchange.
            </p>

            <p style={{ fontSize: "1.1rem" }}>
              For any other product or service from KBPL, please refer to the
              respective document of the product or service you have obtained.
            </p>
            <hr></hr>
            <h2 className="mt-4 fs-1">Key Points :</h2>
            <ul
              className="list-group list-group-flush"
              style={{ fontSize: "1.1rem" }}
            >
              <li className="list-group-item">
                <strong>Service Discontinuation:</strong> By initiating a
                refund, you will be removed from the Kryzen app and all related
                services offered by Kryzen Biotech Pvt. Ltd. (KBPL). Your
                subscription will continue until the end of the current period,
                after which it will be cancelled. No partial refunds will be
                issued.
              </li>
              <li className="list-group-item">
                <strong>Gift Cards & Coupons:</strong> If a gift card or coupon
                code was applied during your purchase, the refund will only
                cover the amount paid, excluding discounts.
              </li>
              <li className="list-group-item">
                <strong>Transaction Fees:</strong> Payment gateway charges
                incurred during the transaction will be deducted from your
                refund. KBPL does not control the time taken by payment gateways
                to process your refund.
              </li>
              <li className="list-group-item">
                <strong>Refund Processing Time:</strong> KBPL will process your
                refund within 3 to 10 business days after approval. The actual
                time for the refund to reflect in your account depends on the
                payment gateway or bank.
              </li>
              <li className="list-group-item">
                <strong>Right to Decline:</strong> KBPL reserves the right to
                decline the sale of any product or service at any time and, if
                applicable, refund the money.
              </li>
              <li className="list-group-item">
                <strong>Billing History:</strong> We retain your billing records
                for 1 year after the refund for accounting purposes.
              </li>
            </ul>
            <hr></hr>
            <div className="mt-5">
              <p className="mb-1" style={{ fontSize: "1.3rem" }}>
                📧 For any questions or concerns, contact us:
              </p>
              <a
                href="mailto:contact@kryzen.com"
                className=""
              >
                contact@kryzen.com
              </a>
            </div>
          </div>
        </div>
      </div>

      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default Refundpolicy;
